import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Agent from "../../../Network/Agent";
import {Snackbar, SnackbarContent} from "@mui/material";
import ToolBar from "../../../Components/Elements/ToolBar";
import InputPrimary from "../../../Components/Elements/InputPrimary";
import {handleSnackbarClose} from "../../../Components/Utils/utilities";
import ButtonPrimary from "../../../Components/Elements/ButtonPrimary";

const ProductsQuickEdit = React.memo((props) => {
    const [products , setProducts] = useState([])
    const [changedProducts , setChangedProducts] = useState([])
    const [focusedProductCode , setFocusedProductCode] = useState("")
    const [focusedProductPrice , setFocusedProductPrice] = useState(null)

    const [submitBtnDisplay , setSubmitBtnDisplay] = useState("d-none")
    const [submitBtnIsLoading , setSubmitBtnIsLoading] = useState(false)

    const [snackbarOpen , setSnackbarOpen] = useState(false)
    const [snackbarMessage , setSnackbarMessage] = useState("")

    const params = useParams();
    const categoryCode = params.arg;
    const storeUsername = window.location.host.split(".")[0];
    const navigate = useNavigate()

    const vertical = "bottom"
    const horizontal = "center"

    const getProductList = () => {
        Agent.Product.getListForQuickEdit(categoryCode,storeUsername)
            .then(response => {
                const products = response.data.result.products
                setProducts(products)
            })
            .catch(error => {
                console.log(error.response)
            })
    }

    const handleChange = (e) => {
        setSubmitBtnDisplay("d-block")
        setFocusedProductPrice(e.target.value)
    }
    const handleBlur = () => {
        changedProducts[focusedProductCode] = focusedProductPrice
        setChangedProducts(changedProducts)
    }

    const handleSubmitBTN = () => {
        let finalList = []
        for (const i in changedProducts) {
            finalList.push({
                code : i,
                price : changedProducts[i]
            })
        }
        setSubmitBtnIsLoading(true)

        const data = {
            products : finalList
        }
        Agent.Product.setListOfQuickEdit(data , storeUsername)
            .then(response => {
                setSubmitBtnIsLoading(false)
                setSnackbarMessage(response.data.message)
                setSnackbarOpen(true)
                setSubmitBtnDisplay("d-none")
                setChangedProducts([])
                getProductList()
            })
            .catch(error => {
                setSubmitBtnIsLoading(false)
                console.log(error)
            })

        console.log(finalList)

    }

    useEffect(() => {
        getProductList()
    } , [])

    return(
        <>
            <ToolBar
                customClasses={'box-shadow'}
                title={'محصولات'}
                navigate={()=>{navigate(-1)}}>
                <div className={submitBtnDisplay}
                     onClick={handleSubmitBTN}>
                    <ButtonPrimary
                        mode="light-mode"
                        spinnerClasses="cl-blue"
                        isLoading={submitBtnIsLoading}>
                        <div className="mobile-h4 desktop-h4 cl-blue">
                            تایید
                        </div>
                    </ButtonPrimary>
                </div>
            </ToolBar>
            <div className="container mt-4">
                <div className="row">
                    {
                        products.length
                            ? products.map(({title , price , code}) => {
                                const productPrice = code in changedProducts ? changedProducts[code] : price
                                return(
                                    <div key={code} className="col-12 border-bottom">
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <div className="product-quick-edit-title-cnt w-50">
                                                {title}
                                            </div>
                                            <div className="product-price-cnt w-50">
                                                <InputPrimary inputClasses="dir-ltr"
                                                              name={code}
                                                              type="text"
                                                              placeholder="قیمت محصول را وارد کنید"
                                                              onFocus={()=>{
                                                                  setFocusedProductCode(code)
                                                                  setFocusedProductPrice(productPrice)
                                                              }}
                                                              onBlur={handleBlur}
                                                              value={
                                                                  focusedProductCode===code
                                                                  ? (focusedProductPrice ?? price)
                                                                  : productPrice
                                                              }
                                                              onChange={handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            : <div className="mobile-h5 desktop-h5 text-center mt-48">هیچ محصولی وجود ندارد.</div>
                    }
                </div>
            </div>

            <Snackbar open={snackbarOpen}
                      autoHideDuration={4000}
                      onClose={() => {
                          handleSnackbarClose()
                          setSnackbarOpen(false);
                      }}
                      anchorOrigin={{vertical , horizontal}}
                      key={vertical + horizontal}>
                <SnackbarContent
                    className="dir-rtl font-family-dana"
                    message={snackbarMessage} />
            </Snackbar>
        </>
    )
})

export default ProductsQuickEdit